import { FC } from 'react';
import { CellContainer } from '@/_components';
import { CellDateProps } from './CellDate.types';

export const CellDate: FC<CellDateProps> = ({ children }) => {
  return <CellContainer width={144}>{children}</CellContainer>;
};
